var dataLinks = {
	/**
	 * Initialize data links functionality by adding click event listener
	 *
	 * @param {HTMLElement} target - The target element to attach the click listener to
	 * @returns {void}
	 */
	init: function (target) {
		target.addEventListener('click', (event) => this.handleDataLinkClick(event.target));
	},

	/**
	 * Handle click events for elements with data-link attribute
	 * Redirects to the URL specified in the data-link attribute
	 *
	 * @param {Event} event - The click event object
	 * @returns {void}
	 */
	handleDataLinkClick: function (target) {
		const linkElement = target.closest('[data-link]');
		if (linkElement) {
			const dataLink = linkElement.getAttribute('data-link');
			if (dataLink && dataLink.trim() !== '') {
				window.location.href = dataLink;
			}
		}
	},
};

export default dataLinks;
